import { Link } from 'react-router-dom';
import { Heading, Text } from '../../styledComponents';
import downloadIcon from '../../../assets/images/download.svg';
import openLinkIcon from '../../../assets/images/openLink.svg';
import styles from './ResourceCard.module.css';

import linkIcon from '../../../assets/icons/link.svg';
import pdfIcon from '../../../assets/icons/pdf.svg';
// import galleryIcon from '../../../assets/icons/gallery.svg';

type ResourceCardProps = {
  title: string;
  subText: string | undefined;
  type: string;
  link: string;
};

export default function ResourceCard({ title, subText, type, link }: ResourceCardProps) {
  return (
    <div className={styles.resourceCard}>
      <a href={link} target="_blank" rel="noreferrer">
        <div className={styles.topContainer}>
          {type === 'link' && <img src={linkIcon} alt="link" width={60} />}
          {type === 'media' && subText === 'PDF' && <img src={pdfIcon} alt="pdf" width={40} />}
          {type === 'media' && subText !== 'PDF' && <img src={link} alt="gallery" className={styles.previewImage} />}
        </div>
      </a>
      <div className={styles.bottomContainer}>
        <div className={styles.leftDiv}>
          <Heading as="h4" fontSize="16px" fontWeight="500" lineHeight="24px">
            {title}
          </Heading>
          <Text fontSize="14px">{subText}</Text>
        </div>
        <div className={styles.righttDiv}>
          {type === 'media' && (
            <Link to={link} target="_blank" download>
              <span>
                <img src={downloadIcon} alt="download" />
              </span>
            </Link>
          )}
          {type === 'link' && (
            <a href={link} target="_blank" rel="noreferrer">
              <span>
                <img src={openLinkIcon} alt="open link" />
              </span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
